import { useQuery } from '@tanstack/react-query'
import { useCompanies } from 'contexts/CompaniesContext'
// import { useCompanies } from 'contexts'
import { AuctionDTO } from 'models/dtos'
import { currentQueryService } from 'utils/api/queries'

const useGetAuction = (auctionNo: string) => {
  const { filteringCompaniesIds } = useCompanies()
  const query = useQuery<AuctionDTO, Error>({
    queryKey: ['useGetAuction', auctionNo, filteringCompaniesIds],
    queryFn: () => currentQueryService.getAuction(auctionNo, filteringCompaniesIds),
    retry: false,
  })
  return query
}

export { useGetAuction }
